// devuelve el flat de usuario logueado
export const isLoggedIn = state => state.isLoggedIn
export const userData = state => state.userData
export const pending = state => state.pending
export const errorMsj = state => state.errorMsj